import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { hideWarning } from '../../../redux/actions/snackbarActions';
import { Snackbar, SnackbarContent, IconButton, Icon, Typography } from '@material-ui/core';
import { instajobTheme } from '../../helpers/instajobTheme';

class WarningSnackbar extends Component {
    render() {
        const { message, show, hideWarning } = this.props;
        return (
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={show}
                autoHideDuration={6000}
                onClose={hideWarning}>
                <SnackbarContent
                    aria-describedby="client-snackbar"
                    style={{ backgroundColor: instajobTheme.palette.secondary.main }}
                    message={
                        <Typography variant="body1" style={{ padding: 0 }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <Icon style={{ marginRight: 15 }}>warning</Icon>
                                {message}
                            </div>
                        </Typography>
                    }
                    action={[
                        <IconButton key="close" aria-label="Close" color="inherit" onClick={hideWarning}>
                            <Icon>close</Icon>
                        </IconButton>
                    ]}
                />
            </Snackbar>
        );
    }
}



const mapWarningStateToProps = store => ({
    message: store.snackbarState.message.warning,
    show: store.snackbarState.show.warning
});

const mapWarningActionsToProps = dispatch => (
    bindActionCreators({ hideWarning }, dispatch)
);

// const mapDangerStateToProps = store => ({
//     message: store.snackbarState.message.danger,
//     show: store.snackbarState.show.danger
// });

// const mapDefaultStateToProps = store => ({
//     message: store.snackbarState.message.default,
//     show: store.snackbarState.show.default
// });

export default connect(mapWarningStateToProps, mapWarningActionsToProps)(WarningSnackbar);